import { Fragment, useCallback, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useSelector } from 'react-redux';
import ConfirmDialog from '../../common/Confirm.component';
import { fetchAPI } from '../../../api/request';
import Loading from '../../common/Loading.component';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import Alert from '../../common/Alert.component';

const DISABLE_DELETE_MOVE = 'DELIVERED';

const MoveItem = ({
  data,
  handleSuccess = () => {},
  statusLogbook,
  module,
  item,
}) => {
  const { query } = module;
  const { jwt } = useSelector((state) => state.login);
  const [loading, setLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [value, setValue] = useState(null);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleClose = useCallback(() => {
    setOpenDelete(false);
    setValue(null);
  }, []);

  const handleOpen = useCallback((item) => {
    setOpenDelete(true);
    setValue(item);
  }, []);

  // eslint-disable-next-line
  const onSuccess = useCallback(() => {
    setSuccess(true);
    handleSuccess();
  }, [handleSuccess]);

  const onError = useCallback((error) => {
    setLoading(false);
    setError(error);
  }, []);

  const onDeleteAction = useCallback(() => {
    fetchAPI(query.delete.move, { id: value.id }, '', {}, jwt)
      .then(() => {
        onSuccess();
      })
      .catch(onError);
  }, [onSuccess, jwt, onError, value, query]);

  return (
    <Fragment>
      {loading && <Loading />}
      {success && <Alert severity='success'>{'Success!!'}</Alert>}

      {error && (
        <Alert severity='error'>
          {error?.response?.data?.error?.message || 'An error has occurred'}
        </Alert>
      )}
      <Tooltip title='Move the item to the items list'>
        <IconButton
          color='error'
          onClick={() => handleOpen(item)}
          disabled={
            data?.length <= 1 ||
            statusLogbook === DISABLE_DELETE_MOVE ||
            !!item?.attributes?.stock_available
          }
        >
          <RestoreFromTrashIcon />
        </IconButton>
      </Tooltip>

      <ConfirmDialog
        open={openDelete}
        onClose={handleClose}
        title='Are you sure you want to delete this?'
        description='This will be moved to the item list with the status NEW ITEM. You cannot undo this action.'
        cancelAction={handleClose}
        confirmAction={onDeleteAction}
      />
    </Fragment>
  );
};

export default MoveItem;
